/**
 * Système de panier "liste de commande" pour le mode borne.
 * Ne touche jamais au vrai panier Shopify — tout est stocké
 * localement (localStorage) pour la session de l'appareil.
 */
(function () {
var STORAGE_KEY = 'kioskCartItems';

function getItems() {
try {
var raw = localStorage.getItem(STORAGE_KEY);
return raw ? JSON.parse(raw) : [];
    } catch (e) {
return [];
    }
  }

function saveItems(items) {
try {
localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
updateBadge();
document.dispatchEvent(new CustomEvent('kiosk-cart:updated', { detail: { items: items } }));
  }

function addItem(product) {
var items = getItems();
var existing = items.find(function (i) { return i.id === product.id; });
if (existing) {
existing.quantity += product.quantity || 1;
    } else {
items.push({
id: product.id,
title: product.title,
price: product.price,
image: product.image || '',
sku: product.sku || '',
quantity: product.quantity || 1
      });
    }
saveItems(items);
  }

function updateQuantity(id, quantity) {
var items = getItems();
var item = items.find(function (i) { return i.id === id; });
if (!item) return;
if (quantity <= 0) {
items = items.filter(function (i) { return i.id !== id; });
    } else {
item.quantity = quantity;
    }
saveItems(items);
  }

function removeItem(id) {
var items = getItems().filter(function (i) { return i.id !== id; });
saveItems(items);
  }

function clear() {
saveItems([]);
  }

function getTotal() {
return getItems().reduce(function (sum, i) {
return sum + (i.price * i.quantity);
    }, 0);
  }

function getCount() {
return getItems().reduce(function (sum, i) {
return sum + i.quantity;
    }, 0);
  }

function updateBadge() {
var count = getCount();
document.querySelectorAll('[data-kiosk-cart-count]').forEach(function (el) {
el.textContent = count;
el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

function setItems(items) {
saveItems(items);
  }

window.KioskCart = {
getItems: getItems,
addItem: addItem,
updateQuantity: updateQuantity,
removeItem: removeItem,
clear: clear,
getTotal: getTotal,
getCount: getCount,
updateBadge: updateBadge,
setItems: setItems
  };

document.addEventListener('DOMContentLoaded', updateBadge);
})();